export default __webpack_public_path__ + "static/media/linkedin.3eb725d5.svg";